import { render } from "./PayError.vue?vue&type=template&id=29cb6e92&scoped=true&ts=true"
import script from "./PayError.vue?vue&type=script&lang=ts"
export * from "./PayError.vue?vue&type=script&lang=ts"

import "./PayError.vue?vue&type=style&index=0&id=29cb6e92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cb6e92"]])

export default __exports__